import React from 'react';

function ModalUpsellProductDetailsGallery({ product }) {
  // Early exit if there are no images
  if (!product?.images?.length) {
    return <></>;
  }

  return (
    <>
      {product.images.map((image, index) => (
        <div key={index} className="product-detail__media">
          <img
            src={image.src}
            alt={image.alt}
            className="product-detail__image"
          />
        </div>
      ))}
    </>
  );
}

export default ModalUpsellProductDetailsGallery;